import { z } from 'zod';
import { ORG_ROLES } from '../constants/orgRoles.js';
export const orgMemberUpdateSchema = z.object({
    role: z.enum(ORG_ROLES),
});
//# sourceMappingURL=org.js.map